import { gql } from "@apollo/client";

const REMOVE_INTERVIEW_RESPONSE = gql`
  mutation removeInterviewResponse($input: RemoveInterviewResponseInput!) {
    removeInterviewResponse(input: $input) {
      id
    }
  }
`;

export { REMOVE_INTERVIEW_RESPONSE };
